export default function encodeCol(
    columnVisibilityModel: object,
): [string, string[]] {
    const keys = Object.keys(columnVisibilityModel);
    const str = keys
        .map(
            (key, i) =>
                `${i}+${
                    columnVisibilityModel[
                        key as keyof typeof columnVisibilityModel
                    ]
                        ? '1'
                        : '0'
                }`,
        )
        .join(',');
    return [str, keys];
}
